const Dashboard = '/dashboard';
const PollutionMap = '/';
const PollutionVariation = '/pollutionvariation';
const Statistics = '/statistics';
const Cams = '/cams';
const TermsOfUse = '/termsofuse';

export const StaticRoutes = {
	Dashboard, PollutionMap, PollutionVariation, Statistics, Cams, TermsOfUse
};

export const routes = [
	{
		url: Dashboard,
		name: 'dashboard',
		exact: true,
		component: 'Dashboard'
	},
	{
		url: PollutionMap,
		name: 'pollutionmap',
		exact: true,
		component: 'PollutionMap'
	},
	{
		url: PollutionVariation,
		name: 'pollutionvariation',
		exact: true,
		component: 'PollutionVariation'
	},
	{
		url: Statistics,
		name: 'statistics',
		exact: true,
		component: 'Statistics'
	},
	{
		url: Cams,
		name: 'cams',
		exact: true,
		component: 'Cams'
	},
	{
		url: TermsOfUse,
		name: 'termsofuse',
		exact: true,
		component: 'TermsOfUse'
	},
];

const combined = {StaticRoutes, routes};

export default combined;
